<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('organizations')">Cardápios</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ title }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nome" :error="form.errors.nome" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.descricao" :error="form.errors.descricao" class="pr-6 pb-8 w-full lg:w-1/2" label="Descrição" />

          <text-input v-model="form.perfil" :error="form.errors.perfil" class="pr-6 pb-8 w-full lg:w-1/2" suffix-label="" label="https://cardapio.automaserv.com.br/profile/" placeholder="perfil" />

          <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo">
            <option value="S">STOC SERV</option>
            <option value="C">STOC CHEF</option>
            <option value="M">Visualizar produtos com interesse</option>
            <option value="V">Visualizar produtos sem botões</option>
          </select-input>
          <text-input v-model="form.cnpj" :mask="'##.###.###/####-##'" type="mask" :error="form.errors.cnpj" class="pr-6 pb-8 w-full lg:w-1/2" label="CNPJ" />
          <text-input v-model="form.telefone" :mask="'+55 (##) #####-####'" type="mask" :error="form.errors.telefone" class="pr-6 pb-8 w-full lg:w-1/2" label="Whatsapp" />
        </div>
        <div class="px-8 -mr-6 mb-8 flex flex-col flex-wrap">
          <loading-button :loading="form.processing" class="btn-indigo w-full lg:w-1/2" type="button" @click.native="toggleShow"> {{ textButtonImageChange }}</loading-button>
          <my-upload v-model="show" field="img" :width="200" :height="200" lang-type="pt-br" img-format="png" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess" @crop-upload-fail="cropUploadFail" />
          <div class="w-full lg:w-1/2 flex flex-row justify-center mt-2">
            <img :src="form.foto" class="w-40" />
          </div>
          <span v-if="form.errors.foto" class="text-sm text-red-500"> {{ form.errors.foto }}</span>
        </div>

        <div class="w-full flex px-8">
          <span>Banco de Dados</span>
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.host" :error="form.errors.host" class="pr-6 pb-8 w-full lg:w-1/2" label="Host/IP" />
          <text-input v-model="form.database" :error="form.errors.database" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome Banco" />
          <text-input v-model="form.username" :error="form.errors.username" class="pr-6 pb-8 w-full lg:w-1/2" label="Uśuario" />
          <text-input v-model="form.password" type="password" :error="form.errors.password" :placeholder="passwordPlaceholder" class="pr-6 pb-8 w-full lg:w-1/2" label="Senha" />
          <text-input v-model="form.port" type="mask" :mask="'######'" :error="form.errors.port" class="pr-6 pb-8 w-full lg:w-1/2" label="Porta" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <button v-if="editMode" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Apagar Cardápio</button>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit"> {{ submitTextButton }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import myUpload from 'vue-image-crop-upload/upload-2'

export default {
  name: 'CreateOrEdit',
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    myUpload,
  },
  layout: Layout,
  props: {
    organization: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      show: false,
      imgDataUrl: '',
      form: this.$inertia.form({
        idEmpresa: null,
        nome: null,
        perfil: null,
        descricao: null,
        host: null,
        database: null,
        username: null,
        password: null,
        port: null,
        cnpj: null,
        foto: null,
        tipo: null,
        telefone: null,
      }),
    }
  },
  computed: {
    textButtonImageChange(){
      return this.form.foto ? 'Editar foto' : 'Selecionar foto'
    },
    title() {
      return this.organization.idEmpresa ? 'Editar' : 'Criar'
    },
    editMode() {
      return this.organization.idEmpresa ? true : false
    },
    submitTextButton() {
      return this.organization.idEmpresa ? 'Atualizar cardápio' : 'Criar cardápio'
    },
    passwordPlaceholder(){
      return this.editMode ? 'Deixe vázio caso não queira alterar a senha' : ''
    },
  },
  created(){
    if(this.editMode){
      this.form = {...this.form, ...this.organization}
    }
  },
  remember: 'form',
  methods: {
    submit(){
      if(this.editMode){
        this.update()
      }else{
        this.store()
      }
    },
    store() {
      this.form.post(this.route('organizations.store'))
    },
    update() {
      this.form.put(this.route('organizations.update', this.organization.idEmpresa))
    },
    destroy() {
      if (confirm('Você deseja mesmo apagar esse cardápio?')) {
        this.$inertia.delete(this.route('organizations.destroy', this.organization.idEmpresa))
      }
    },
    toggleShow() {
      this.show = !this.show
    },
    cropSuccess(imgDataUrl) {
      console.log('-------- crop success --------')
      this.form.foto = imgDataUrl
      this.form.errors.foto = null
    },
    cropUploadSuccess(jsonData, field) {
      console.log('-------- upload success --------')
      console.log(jsonData)
      console.log('field: ' + field)
    },
    cropUploadFail(status, field) {
      console.log('-------- upload fail --------')
      console.log(status)
      console.log('field: ' + field)
    },
  },
}
</script>
